export class Validator {
  constructor(app) {
    this.app = app;
    this.rules = {};
  }

  define(rules) {
    this.rules = { ...this.rules, ...rules };
  }

  apply(name, context) {
    if (this.checkRule(name)) {
      const code = this.rules[name].code;

      if (code && code === context.errorStatus) return true;
      if (this.rules[name].rule) return this.rules[name].rule(context);
    }
    return false;
  }

  getElement(name) {
    const rule = this.rules[name];
    if (rule) {
      return {
        message: rule.messages[this.app.$lang.vm.locale],
        selector: rule.selector,
      };
    }
  }

  checkRule(rule) {
    return !!this.rules[rule];
  }
}

export default (ctx, inject) => {
  const validator = new Validator(ctx.app);
  inject('validator', validator);
};
